
/* global  Cesium */

/**
 * 获取ImageLayer 中 单图影像
 * @param {*} layerInfo
 */
function getSingleLayerInfo (layerInfo) {
  const _imageUrl = layerInfo.url
  const extent = layerInfo.extent
  // 3D 单图赋值
  const singleParam3D = {
    url: _imageUrl,
    rectangle: Cesium.Rectangle.fromDegrees(
      extent[0], extent[1],
      extent[2], extent[3]
    )
  }

  const singleImageLayer = new Cesium.SingleTileImageryProvider(singleParam3D)

  return singleImageLayer
  // cesium 使用 返回值进行移除
  // fireSingleImageLayer3D = layers.addImageryProvider(_3DImageLayer)
}

export { getSingleLayerInfo }
